<template lang="pug">
.modal-backdrop(v-if="visible" @touchmove.prevent)
  .modal-container
    .close(v-if="closeIcon" @click="close")
    .modal-header(v-if="title")
      span {{ title }}
    .modal-body
      slot(name="body")
    .modal-footer
      slot(name='footer')
        .btn(@click="handleClick") {{ btnText }}

</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    btnText: {
      type: String,
      default: '确认',
    },
    closeIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  methods: {
    open() {
      this.visible = true;
    },
    handleClick() {
      this.visible = false;
      this.$emit('ok');
    },
    close() {
      this.visible = false;
      this.$emit('close');
    },
  },
};
</script>

<style lang="less" scoped>
.modal-backdrop {
  position: absolute;
  z-index: 1000;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.49);
}

.modal-container {
  position: absolute;
  right: 0;
  left: 0;
  margin: 1rem auto 0;
  width: 3rem;
  min-height: 2.65rem;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background: #fff;

  .close {
    position: absolute;
    width: 0.14rem;
    height: 0.14rem;
    top: 0.13rem;
    right: 0.13rem;

    &::before,
    &::after {
      position: absolute;
      content: ' ';
      background-color: #bcc4cc;
      left: 50%;
      width: 2px;
      height: 0.14rem;
    }

    &::before {
      transform: rotate(45deg);
    }

    &::after {
      transform: rotate(-45deg);
    }
  }

  .modal-header {
    padding: 0.2rem 0 0.15rem 0;
    text-align: center;
    font-size: 18px;
    font-weight: 400;
    color: #fff;
  }

  .modal-body {
    flex: 1;
    overflow-y: auto;
    padding: 0.2rem 0.15rem 0;
  }

  .modal-footer {
    width: 100%;
    display: flex;
    justify-content: center;
    padding: 0.15rem;

    .btn {
      background: #0b82f1;
      border-radius: 3px;
      font-size: 16px;
      line-height: 0.41rem;
      height: 0.41rem;
      width: 2.7rem;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
